
<template>
  <v-container fluid>
    <one-template></one-template>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import OneTemplate from '../../components/templates/OneTemplate.vue'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'OneTemplatePage',
  //mixins: [ validations ],
  components: {
    OneTemplate
    //ComponentName: () => import(''),
  },
  data() {
    return {
      
    }
  },
  methods: {
    name() {
      
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>